// BEWARE: this is the list of routes that are allowed
// whenever adding a new route, make sure to add it to this list!

const ROUTES = {
  HOMEPAGE: '/',
  VERIFY_EMAIL: '/verify-email',
  ONBOARDING: '/onboarding',
  INVEST: '/invest',
  INVEST_CATEGORY: '/invest/:category',
  SWAP: '/swap',
  DOTC: '/dotc',
  DOTC_CATEGORY: '/dotc/:category?',
  POOLS: '/pools',
  POOLS_CATEGORY: '/pools/:category?',
  POOL_DETAILS: '/pool/:address',
  LENDING_AND_BORROWING: '/lend-borrow',
  WALLETS: '/wallets',
  PASSPORT: '/passport',
  TEST_FAUCET: '/faucet',
  VOUCHERS: '/vouchers',
  VOUCHERS_PAYMENT: '/vouchers/payment',
  VOUCHERS_LIST: '/vouchers/list',
  STAKING: '/staking',
  STAKING_CATEGORY: '/staking/:category',
}

export { ROUTES }
